import Entity from '../Entity';

export default class AnnouncementCategory implements Entity {
  constructor(public id: number, public name: string) {}
}
